<template>
        <v-container fluid  fill-height >
        <v-row  align="center"
      justify="center">

                <v-col cols="12" align="center"
      justify="center">
                    <h1>{{labels.nguests}}</h1>
                </v-col>
                

            <v-col cols="12" >
                <v-row align="center"
      justify="center">
                <v-col xs4 align="center"
      justify="center">
                    <v-btn  rounded large @click="menoospiti" :color="nospiti > 1?'primary':'grey'" style="height:100px; width:100px; border-radius:100px"><v-icon large>mdi-minus</v-icon></v-btn>
                </v-col>
                <v-col  xs4 align="center"
      justify="center">
                    <h1 class="display-4">{{nospiti}}</h1>
                </v-col>
                <v-col  xs4 align="center"
      justify="center">
                   <v-btn rounded dark large @click="piuospiti" :color="nospiti < nmaxospiti?'primary':'grey'" style="height:100px; width:100px; border-radius:100px"><v-icon large>mdi-plus</v-icon></v-btn>
                </v-col>
                </v-row>
            </v-col>

            <v-col cols="12" align="center"
      justify="center">
                    <v-btn rounded dark large @click="submit" color="green">{{labels.next}}</v-btn>
            </v-col>



        </v-row>
    </v-container>
</template>
<script>
export default {
    data() {

       return {
               nospiti: 1,
               idprenotazione:null,
       };
    },
    computed: {
      labels(){
        return this.$store.state.labels;
      },
      nospitiiniziali(){
          let retval = (this.$store.state.reservation.visitors.length || 0) + 1 ;
        return retval
      },
      nmaxospiti (){
        let retval = this.nospitiiniziali
        if(this.$store.state.config.consentiaumentonospiti){// se la struttura consente l'aumento degli ospiti rispetto ai prenotanti
            retval=99
          }
         return retval
      }
    },
    mounted() {
        this.nospiti = this.nospitiiniziali;
        this.idprenotazione= this.$route.params.reservationid;
    },
    methods: {
        submit () {
                this.$store.commit("setnumberofguests", this.nospiti);
                //window.location.href = "#/precheckin/"+this.idprenotazione;
                this.$router.push({ path: `/precheckin/${this.idprenotazione}` })
            },
            piuospiti () {
                if(this.nospiti < this.nospitiiniziali || this.nospiti < this.nmaxospiti ){
                    this.nospiti++;
                }
            },
            menoospiti () {
                if(this.nospiti >1 ){
                    this.nospiti--;
                }

            },
    }
}
</script>